import React, { useState } from 'react';
import { IDriveInfo } from 'types';
import strings from '../../strings/strings.json'

interface Props {
    data: any,
    diskId: any,
    diskRowClicked: (id: IDriveInfo) => void,
    mountButtonClicked: (data: IDriveInfo) => void
}
export default function DiskRowHandler(props: Props) {

    const iconHandler = () => {
        let img = ''
        if (props.data.is_mounted)
            img = 'usb_mounted.svg'
        else
            img = 'usb_mounted_red.svg'

        return img
    }

    const onClickHandler = (data: IDriveInfo) => {
        props.diskRowClicked(data)
    }

    const buttonTextHandler = () => {
        if (props.data.is_mounted)
            return strings.disk_mounted
        else
            return strings.disk_unmounted
    }

    return (
        <div
            className={`flex justify-between px-10  hover:bg-gray-50 py-5 ml-5 rounded-md ${props.data.device === props.diskId ? 'bg-gray-100' : ''}`}
            onClick={() => onClickHandler(props.data)}
        >
            <div>
                <button
                    className={`border border-black rounded-2xl whitespace-nowrap px-6 py-1 text-xs z-10 ${props.data.is_mounted ? '' : 'text-red-500 border-red-500'}`}
                    onClick={() => props.mountButtonClicked(props.data)}
                >
                    {buttonTextHandler()}
                </button>
            </div>
            <div className='flex items-center justify-center'>
                <span className='mr-3 w-96 text-right truncate primary_text_color font-bold VazirEng'>{props.data.device}</span>
                <img className='w-9' src={require(`../../assets/icons/${iconHandler()}`)} alt="Icon" />
            </div>
        </div>
    )
}
